window.Commerce = window.Commerce || {Currency: {}};
window.CommerceModules = window.CommerceModules || [];
document.addEventListener("DOMContentLoaded", function () {
    Commerce.container = document.querySelector('.commerce-container');
    // Add the CSS style that signifies that the javascript was loaded, so we can hide progressive stuff
    let style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet){
        style.styleSheet.cssText= '.commerce-hide-js { display: none !important; }';
    } else {
        style.appendChild(document.createTextNode('.commerce-hide-js { display: none !important; }'));
    }
    document.getElementsByTagName('head')[0].appendChild(style);

    Commerce.resizeContainer = function () {
        if (Commerce.container) {
            let headerHeight = document.body.className.indexOf('commerce_mv30') !== -1 ? 0 : 55;
            Commerce.container.style.height = (window.innerHeight - headerHeight) + 'px';
        }
        if (Commerce.Modal && Commerce.Modal.modal) {
            Commerce.Modal.modal.setAttribute('style', 'height: ' + (Commerce.Modal.modalTitle.offsetHeight + Commerce.Modal.modalContent.scrollHeight) + 'px;');
        }
    };

    if (Commerce.container) {
        window.addEventListener('resize', Commerce.resizeContainer);
        window.addEventListener('load', Commerce.resizeContainer);
        Commerce.resizeContainer();
    }

    // Initialise the different components
    Commerce.Request = new CommerceRequest();
    Commerce.Navigation = new CommerceNavigation();
    Commerce.Grid = new CommerceGrid();
    Commerce.Modal = new CommerceModal();
    Commerce.Fields = new CommerceFields();
    Commerce.ProductsTV = new CommerceProductsTV();
    Commerce.MatrixTV = new CommerceProductMatrixTV();
    Commerce.PricingTV = new CommerceProductPricingTV();

    Commerce.Modules = {};

    for (let i = 0; i < window.CommerceModules.length; i++) {
        let mod = window.CommerceModules[i],
            name = mod.name;
        try {
            let inst = mod.create(),
                onRender = mod.onRender ? function (dom) {
                    return (inst[mod.onRender].bind(inst))(dom);
                } : function (dom) { };
            Commerce.Modules[name] = {
                instance: inst,
                onRender: onRender,
            };
        }
        catch (e) {
            console.error(e);
        }
    }

    CommerceNavigation.initComponents(Commerce.container);
});

